import type { FlowStep } from '@/data'
import { getFunnelsURL } from '@/api/client'
import {
  defaultSteps as savingsEstimatesDefaults,
  validateSteps as validateSavingsEstimates,
} from './templates/SavingsEstimates/config'
import { defaultSteps as findingAssistanceDefaults } from './templates/FindingAssistance/config'
import {
  defaultSteps as gettingStartedDefaults,
  validateSteps as validateGettingStarted,
} from './templates/GettingStarted/config'
import { defaultSteps as aiChatLanderDefaults } from './templates/AIChatLander/config'

export interface HtmlTemplate {
  id: string
  name: string
  description: string
  previewImage: string
  previewUrl: string
  defaultState: FlowStep[]
}

export const htmlTemplates: HtmlTemplate[] = [
  {
    id: 'savings-estimates',
    name: 'Savings Estimates',
    description: 'Debt estimate funnel with debt question and form step',
    previewImage: '/images/templates/savings-estimates-template.png',
    previewUrl: `${getFunnelsURL()}/t/savings-estimates/`,
    defaultState: savingsEstimatesDefaults,
  },
  {
    id: 'finding-assistance',
    name: 'Finding Assistance',
    description:
      'Qualification funnel with debt question, qualification steps, verification, and form',
    previewImage: '/images/templates/finding-assistance-template.png',
    previewUrl: `${getFunnelsURL()}/t/finding-assistance/`,
    defaultState: findingAssistanceDefaults,
  },
  {
    id: 'getting-started',
    name: 'Getting Started',
    description:
      'Simple two-step lead capture funnel with contact info and verification details',
    previewImage: '/images/templates/getting-started-template.png',
    previewUrl: `${getFunnelsURL()}/t/getting-started/`,
    defaultState: gettingStartedDefaults,
  },
  {
    id: 'chat',
    name: 'AI Chat Lander',
    description:
      'Branded landing page where an AI chat handles form submission and chat',
    previewImage: '/images/templates/ai-chat-lander-template.png',
    previewUrl: `${getFunnelsURL()}/t/chat/`,
    defaultState: aiChatLanderDefaults,
  },
  {
    id: 'chat-live',
    name: 'AI Chat Live',
    description:
      'Unbranded AI chat landing page — only the prompt version is configurable',
    previewImage: '/images/templates/chat-live-template.png',
    previewUrl: `${getFunnelsURL()}/t/chat-live/`,
    defaultState: aiChatLanderDefaults,
  },
]
// Templates rendered by the AI chat lander builder
export const aiChatTemplates = ['chat', 'chat-live']

export function getDefaultState(templateSlug: string): FlowStep[] {
  const template = htmlTemplates.find((t) => t.id === templateSlug)
  return structuredClone(template?.defaultState ?? [])
}

export function getValidationErrors(
  templateSlug: string,
  steps: FlowStep[],
): string[] {
  switch (templateSlug) {
    case 'savings-estimates':
      return validateSavingsEstimates(steps)
    case 'getting-started':
      return validateGettingStarted(steps)
    default:
      return []
  }
}
